module.exports = __webpack_public_path__ + "img/tezos.776f38b0.png";